import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  textAlign: 'center',
  background: (p) => p.palette.success[25],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.success[400],
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(1),
  width: '100%',
};
